"use client";

import {JSX} from "react";

import dynamic from "next/dynamic";

import {type PointsMapInstance} from "@/features/rental";

import {Spinner} from "@/shared/ui/feedback/spinner";

interface PointsMapViewProps {
    model: PointsMapInstance;
    className?: string;
    isLoading?: boolean;
}

const PointsMapGoogleView = dynamic(() => import("./property-map-google.view").then((mod) => mod.PointsMapGoogleView), {
    ssr: false,
});

export function PointsMapView({model, className, isLoading}: PointsMapViewProps): JSX.Element {
    return (
        <div style={{position: "relative", width: "100%", height: "100%", pointerEvents: "none"}}>
            <div style={{position: "absolute", inset: 0, pointerEvents: "auto"}}>
                <PointsMapGoogleView model={model} className={className} />
            </div>
            {isLoading && (
                <>
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                            backdropFilter: "blur(2px)",
                            zIndex: 999,
                            pointerEvents: "none",
                        }}
                    />
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1000,
                            pointerEvents: "none",
                        }}
                    >
                        <Spinner size="large" text="Loading map points..." />
                    </div>
                </>
            )}
        </div>
    );
}
